var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_2434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 9.00016C1.8335 5.04212 5.04212 1.8335 9.00016 1.8335C12.9582 1.8335 16.1668 5.04212 16.1668 9.00016C16.1668 12.9582 12.9582 16.1668 9.00016 16.1668C5.04212 16.1668 1.8335 12.9582 1.8335 9.00016Z",
    fill: "#212129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 5C9.36836 5 9.66683 5.29848 9.66683 5.66667V7.47201C10.2555 7.7292 10.6668 8.31653 10.6668 9C10.6668 9.21493 10.6262 9.4204 10.552 9.60907L11.4716 10.5286C11.7319 10.7889 11.7319 11.2111 11.4716 11.4714C11.2112 11.7317 10.7891 11.7317 10.5288 11.4714L9.60923 10.5519C9.42056 10.626 9.2151 10.6667 9.00016 10.6667C8.0797 10.6667 7.3335 9.92047 7.3335 9C7.3335 8.31653 7.74483 7.7292 8.3335 7.47201V5.66667C8.3335 5.29848 8.63196 5 9.00016 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.cee2a718322decf41ee28137bd78103f.svg";
export { ForwardRef as ReactComponent };